import { RequestStatus } from 'features/request/requestSlice';
import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useCallback, useMemo } from 'react';

import { catalogUpdateWorkTypeGql } from '../catalogTypesWorkQuery';

interface IUseEditWorkTypeItem {
    onSuccessHandler: () => void;
}

export const useEditWorkTypeItem = ({ onSuccessHandler }: IUseEditWorkTypeItem) => {
    const [typeWorkEditData, typeWorkEditStatus, typeWorkEditError, typeWorkEditRequest] = useRequest({
        requestId: 'typeWorkEdit',
        query: catalogUpdateWorkTypeGql,
        withEffect: false,
        dependenciesUpdater: onSuccessHandler,
    });
    const [resetTypeWorksEditData] = useResetStoreData({ requestId: 'typeWorkEdit' });

    const isSavingInProgress = useMemo(() => typeWorkEditStatus === RequestStatus.FETCHING, [typeWorkEditStatus]);

    const resetEditData = useCallback(() => {
        resetTypeWorksEditData(null);
    }, [resetTypeWorksEditData]);

    return {
        resetEditData,
        typeWorkEditData: typeWorkEditData?.catalogUpdateWorkType,
        typeWorkEditStatus,
        typeWorkEditError,
        typeWorkEditRequest,
        isSavingInProgress,
    };
};
